export const USER_EMAIL_ALREADY_EXISTS_MESSAGE =
  "A user with this email address already exists.";

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function normalizeUserEmail(email: string): string {
  return email.trim().toLowerCase();
}

function hasWhitespace(value: string): boolean {
  for (const ch of value) {
    if (ch === " " || ch === "\t" || ch === "\n" || ch === "\r") {
      return true;
    }
  }
  return false;
}

/** Linear-time email shape check (ReDoS-safe; no regex). */
export function isValidEmailFormat(email: string): boolean {
  const trimmed = email.trim();
  if (trimmed.length === 0 || trimmed.length > 254 || hasWhitespace(trimmed)) {
    return false;
  }

  const atIndex = trimmed.indexOf("@");
  if (atIndex <= 0 || atIndex !== trimmed.lastIndexOf("@")) {
    return false;
  }

  const local = trimmed.slice(0, atIndex);
  const domain = trimmed.slice(atIndex + 1);
  if (local.length === 0 || domain.length === 0) {
    return false;
  }

  const dotIndex = domain.lastIndexOf(".");
  return dotIndex > 0 && dotIndex < domain.length - 1;
}

export function createEmailFormatValidator() {
  return (_: unknown, value: string | undefined) => {
    const email = value?.trim() ?? "";
    if (!email) return Promise.resolve();
    if (!isValidEmailFormat(email)) {
      return Promise.reject(new Error("Invalid email address"));
    }
    return Promise.resolve();
  };
}

export function isUserEmailDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}
